import { BookInterface } from '../interface/book.interface'
import NewReadershipProfileBookFiltersInterface from '../interface/analytics/new-readership-profile-book-filters'

const filterBooksUtil = (
  books: BookInterface[],
  filtersActions?: NewReadershipProfileBookFiltersInterface,
): BookInterface[] => {
  if (books.length === 0 || !filtersActions) {
    return books
  }
  const { publishing_date: publishingDate, edition, format } = filtersActions

  const hasPublishingDateFilter =
    Array.isArray(publishingDate) &&
    publishingDate.some((year) => year !== null)

  const hasEditionFilter = Array.isArray(edition) && edition.length > 0
  const hasFormatFilter = Array.isArray(format) && format.length > 0

  if (!hasPublishingDateFilter && !hasEditionFilter && !hasFormatFilter) {
    return books
  }

  const [startYear, endYear] = publishingDate as Array<number | null>

  return books.filter((ed) => {
    const year = new Date(ed.publishing_date).getFullYear()

    if (hasPublishingDateFilter) {
      if (startYear !== null && endYear !== null) {
        if (year < startYear || year > endYear) return false
      } else if (startYear !== null) {
        if (year !== startYear) return false
      } else if (endYear !== null) {
        if (year !== endYear) return false
      }
    }

    if (hasEditionFilter) {
      if (!edition.includes(ed.edition)) return false
    }

    if (hasFormatFilter) {
      if (!format.includes(ed.format)) return false
    }

    return true
  })
}

export default filterBooksUtil
